import { render, staticRenderFns } from "./BankHolder.vue?vue&type=template&id=67c021f2&scoped=true&"
import script from "./BankHolder.vue?vue&type=script&lang=js&"
export * from "./BankHolder.vue?vue&type=script&lang=js&"
import style0 from "./BankHolder.vue?vue&type=style&index=0&id=67c021f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c021f2",
  null
  
)

export default component.exports